//Conversations
import React, { useEffect, useRef, useState } from "react";
import "./messages.css";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment-timezone";
import {
  FaCheckDouble,
  FaRegClock,
  FaRegPaperPlane,
  FaRegTrashAlt,
} from "react-icons/fa";
import paypalLogo from "../../../assets/images/paypal-logo.png";
import {
  Input,
  InputGroup,
  InputGroupText,
  Label,
  Modal,
  ModalBody,
} from "reactstrap";
import Payment from "../settingsComponents/Payment";
import { setChildId, setOrder } from "../../../redux/slices/MsgSlice";
import { Menu, MenuItem } from "@mui/material";
import { scheduleMessage } from "../../../components/Header/Data3";
import MsgScheduleModal from "../../../components/Header/modals/MsgScheduleModal";
import { useSocket } from "../../../contexts/SocketContext";
import { resetEnlargeImageData } from "../../../redux/slices/ImageSlice";

function Conversation({ message, isChatModal }) {
  const { sendNewMessage } = useSocket();
  const islogin = useSelector((state) => state.user.isLogin);
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = islogin ? JSON.parse(userinfo) : null;
  const isAdmin = user && user.Role === "admin";
  const userId = user?.UserID;
  const [anchorEl, setAnchorEl] = useState(null);
  const [reScheduleModal, setRescheduleModal] = useState(false);
  const dispatch = useDispatch();
  const { selectedConvo } = useSelector((state) => state.messages);
  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

     useEffect(() => {
      dispatch(resetEnlargeImageData());
      return () => {
        dispatch(resetEnlargeImageData());
      };
    }, [dispatch]);

  const handleChange = async (type) => {
    if (type === "Edit") {
      setRescheduleModal(true);
    } else {
      const messageData = {
        messageId: message.Id,
        mType: type,
      };
      await scheduleMessage(messageData);
      sendNewMessage(message);
    }

    handleClose();
  };
  function renderAttachment() {
    const photoUrl = message.Photo;
    if (!photoUrl) return null;

    const fileExtension = photoUrl?.split(".").pop().toLowerCase();
    const isVideo = ["mp4", "webm", "ogg", "mov"].includes(fileExtension);
    const isImage = ["jpg", "jpeg", "png", "gif", "webp"].includes(
      fileExtension
    );

    // Extract imageId and created_by from message (sent from VideoContainer)
    const imageId = message.imageId;
    const vendorId = message.createdBy; // or message.ownerId — use correct one
    const imageTitle = message.image_title || "Attachment";
    const imageDescription = message.image_description || "";

    // Build the enlarge link
    const enlargeLink = `#/enlargeImageView?vendorid=${vendorId}&imageid=${imageId}`;

    // Only show WhatsApp-style card if it's from imageSend flow
    if (message.imageSend === 1 && (isImage || isVideo)) {
      return (
        <div
          className="whatsapp-thumbnail-card"
          style={{
            maxWidth: "280px",
            borderRadius: "12px",
            overflow: "hidden",
            backgroundColor: "#fff",
            boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
            cursor: "pointer",
          }}
          // Click whole card → go to full view
          onClick={() => {
            if (imageId) {
              window.location.hash = enlargeLink;
            }
          }}
        >
          {/* Media Preview */}
          <div style={{ position: "relative" }}>
            {isVideo ? (
              <video
                src={photoUrl}
                muted
                loop
                playsInline
                style={{ width: "100%", height: "200px", objectFit: "cover" }}
              />
            ) : (
              <img
                src={photoUrl}
                alt={imageTitle}
                style={{ width: "100%", height: "200px", objectFit: "cover" }}
              />
            )}

            {/* Play icon for video */}
            {isVideo && (
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  backgroundColor: "rgba(0,0,0,0.6)",
                  borderRadius: "50%",
                  width: "48px",
                  height: "48px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
                  <path d="M8 5v14l11-7z" />
                </svg>
              </div>
            )}
          </div>

          {/* Title & Description */}
          <div style={{ padding: "10px 12px" }}>
            <div
              style={{
                fontWeight: "600",
                fontSize: "15px",
                color: "#111",
                marginBottom: "4px",
                wordBreak: "break-word",
              }}
            >
              {imageTitle || message.image_title}
            </div>
            {imageDescription && (
              <div
                style={{
                  fontSize: "13.5px",
                  color: "#666",
                  lineHeight: "1.4",
                  wordBreak: "break-word",
                }}
              >
                {imageDescription || message.image_description}
              </div>
            )}
          </div>
        </div>
      );
    }

    // Fallback: Old behavior for normal attachments
    if (isImage) {
      return (
        <img
          src={photoUrl}
          alt="attachment"
          className="attachment-image"
          style={{ maxWidth: "250px", borderRadius: "12px" }}
          onClick={() => imageId && (window.location.hash = enlargeLink)}
        />
      );
    }

    if (isVideo) {
      return (
        <div className="video-thumbnail-container">
          <video
            src={photoUrl}
            muted
            autoPlay
            loop
            playsInline
            preload="metadata"
          />
          <div className="video-play-overlay" />
        </div>
      );
    }

    if (fileExtension === "pdf") {
      return (
        <div>
          <iframe
            src={photoUrl}
            width="100%"
            height="500"
            frameBorder="0"
            title="PDF"
          />
        </div>
      );
    }

    return null;
  }
  // function convertToUserTimezone(utcTime) {
  //   let timezone = "America/Los_Angeles"; // Default to system timezone
  //   if (islogin && user?.TimeZone) {
  //     timezone = user?.TimeZone.split(",")[0];
  //   }
  //   const localTime = moment
  //     .utc(utcTime)
  //     .tz(timezone)
  //     .format("YYYY-MM-DD HH:mm:ss");
  //   return localTime;
  // }
  function getMessageStatus() {
    if (
      message.createdBy == userId ||
      (isAdmin && message.messageStatus == 13)
    ) {
      if (message.seenCustomer == 1) {
        return <FaCheckDouble style={{ color: "red" }} title="Read" />;
      }
      return <FaCheckDouble style={{ color: "gray" }} title="Delivered" />;
    }
    return null;
  }
  const userTimeZone = moment.tz.guess();
  const [paymentDetails, setPaymentDetails] = useState({
    description: "",
    amount: "",
    status: "",
  });
  let paymentDescription;
  let PaymentStatus;
  let totalPrice;
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const eventListenerAdded = useRef(false);

  const closeModal = () => {
    setModalIsOpen(false);
  };
  // const [pendingState, setPendingState] = useState("");
  const handlePendingPayment = (event) => {
    const messageId = event.target.id.replace("pendingPayment-", "");
    const clickedMessage = message.Id === parseInt(messageId);
    if (clickedMessage) {
      const paymentDetails = message.Message.replace(
        "payment for chat with",
        ""
      )
        .trim()
        .split(",")
        .map((item) => item.trim());
      setPaymentDetails({
        description: paymentDetails[0],
        amount: paymentDetails[1],
        status: paymentDetails[2],
      });
      setModalIsOpen(true);
      dispatch(setOrder(message?.orderId));
      dispatch(setChildId(message?.Id));
    }
  };

  useEffect(() => {
    const pendingPayments = document.querySelectorAll(
      '[id^="pendingPayment-"]'
    );

    if (message?.createdBy === user?.UserID && !eventListenerAdded.current) {
      // setPendingState(pendingPayments);
      pendingPayments.forEach((element) => {
        element.addEventListener("click", handlePendingPayment);
      });
    }

    // Clean up listeners when the component unmounts or re-renders
    return () => {
      pendingPayments.forEach((element) => {
        element.removeEventListener("click", handlePendingPayment);
      });
    };
  }, [modalIsOpen]); // Dependencies: message or user changes trigger the effect

  useEffect(() => {
    if (message?.orderStatus === "COMPLETED") {
      setModalIsOpen(false);
    }
  }, [message?.orderStatus]);
  const providerZone = selectedConvo?.providerTimezone;
  const CustZone = selectedConvo?.customerTimezone;
  const proTime = providerZone?.split(",")[0];
  const custTime = CustZone?.split(",")[0];
  const proZone = providerZone?.split(",")[1];
  const custZone = CustZone?.split(",")[1];
  const timeZoneFormat = (newDate, timeZone1, timeZone2) => {
    let protimelast, custtimelast;
    if (user?.UserID === message?.customerId) {
      const protime = moment.tz(newDate, timeZone1);
      protimelast = protime.format("MMMM D, YYYY [at] hh:mm A");
      const custtime = moment.tz(protime, timeZone2);
      custtimelast = custtime.format("MMMM D, YYYY [at] hh:mm A");
    } else {
      const protime = moment.tz(newDate, timeZone2);
      protimelast = protime.format("MMMM D, YYYY [at] hh:mm A");
      const custtime = moment.tz(protime, timeZone1);
      custtimelast = custtime.format("MMMM D, YYYY [at] hh:mm A");
    }
    return { protimelast, custtimelast };
  };
  const profilePhoto =
    message?.createdBy !== message.customerId
      ? message?.providerProfilePhoto &&
        message?.providerProfilePhoto.trim() !== ""
        ? message.providerProfilePhoto
        : "https://cdn.pixabay.com/photo/2018/11/13/21/43/avatar-3814049_1280.png"
      : message?.customerProfilePhoto &&
        message?.customerProfilePhoto.trim() !== ""
      ? message.customerProfilePhoto
      : "https://cdn.pixabay.com/photo/2018/11/13/21/43/avatar-3814049_1280.png";
  return (
    <div
      className={`chat-message ${
        message.createdBy === userId || (isAdmin && message.messageStatus == 13)
          ? "own"
          : "other"
      } `}
    >
      <div
        className={`message-content ${
          message.messageStatus == 0 ? "scheduled-msg" : ""
        }`}
        onClick={(e) => {
          if (!message.imageId || !message.createdBy) return;
          e.stopPropagation();
          window.location.hash = `#/enlargeImageView?vendorid=${message.createdBy}&imageid=${message.imageId}`;
        }}
      >
        <div className="d-flex align-items-center mb-1 position-relative">
          <img
            src={user?.Photo}
            alt="Avatar"
            className="rounded-circle border border-1 border-secondary bg-light avatar shadow d-inline-block  "
            width={40}
            height={40}
            style={{
              width: "20px",
              height: "20px",
            }}
          />
          <div
            className="sender  "
            style={{ fontSize: "14px", marginLeft: "5px", fontWeight: "600" }}
          >
            {user?.UserName}
          </div>
          {message?.messageStatus == 0 && (
            <div
              className="position-absolute end-0 me-2"
              style={{ cursor: "pointer" }}
              onClick={(event) => handleMenuClick(event)}
            >
              ⋮
            </div>
          )}
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
            PaperProps={{
              style: {
                minWidth: "100px", // Adjust width as needed
                borderRadius: "10px",
              },
            }}
          >
            <MenuItem className=".wc-msg-menu-item">
              <FaRegPaperPlane className="me-2" />
              <span
                style={{ flexGrow: 1 }}
                onClick={() => handleChange("Send")}
              >
                Send Now
              </span>
            </MenuItem>
            <MenuItem className="wc-msg-menu-item">
              <FaRegClock className="me-2" />
              <span
                style={{ flexGrow: 1 }}
                onClick={() => handleChange("Edit")}
              >
                Change Time
              </span>
            </MenuItem>
            <MenuItem className="wc-msg-menu-item">
              <FaRegTrashAlt className="me-2" />
              <span
                style={{ flexGrow: 1 }}
                className="bg-danger text-white rounded p-1 text-center"
                onClick={() => handleChange("Delete")}
              >
                Delete
              </span>
            </MenuItem>
          </Menu>
        </div>

        {message?.postType != 4 && (
          <p
            className="my-2 p-0 text-dark"
            style={{ fontSize: "medium" ,overflowWrap: "anywhere"}}
            dangerouslySetInnerHTML={{
              __html: (() => {
                const messageText =
                  message.Message ||
                  message.messageComment ||
                  message.giftDescription ||
                  message.Description ||
                  "";

                
                const name =
                  message?.createdBy === user?.UserID
                    ? message?.customerName
                    : message?.senderName;

                
                if (messageText.includes("Click to join zoom meeting")) {
                  // Insert the condition after the "Click to join zoom meeting"
                  const zoomMessage = messageText.replace(
                    "Click to join zoom meeting",
                    `Click to join zoom meeting with ${message?.postName}`
                  );

                  // Render the updated message with the zoom link
                  return zoomMessage;
                }

                if (messageText.startsWith("My Business Profile")) {
                  
                  const detailsArray = messageText
                    .split(",")
                    .map((item) => item.trim());
 
                  const description = detailsArray[0];
                  const userId = detailsArray[1];
                  
                  const htmlContent = `Check my Profile page<br/><a href="/#/userDetails/${userId}" target="_blank" style="text-decoration: underline !important;"> View Profile</a>`;
                  
                  return htmlContent;
                }

                if (
                  messageText.startsWith("Call Scheduled for") ||
                  messageText.startsWith("Call Rescheduled for")
                ) {
                  const dateRegex = /for (\d{4}-\d{2}-\d{2}) at/;
                  const timeRegex = /at (\d{2}:\d{2}) for/;
                  const zoomLinkRegex = /with (.*)$/;
                  const dateMatch = messageText.match(dateRegex);
                  const timeMatch = messageText.match(timeRegex);
                  const zoomLinkMatch = messageText.match(zoomLinkRegex);
                  const extractedData = {
                    date: dateMatch && dateMatch[1],
                    time: timeMatch && timeMatch[1],
                    zoomLink: zoomLinkMatch && zoomLinkMatch[1],
                  };
                  const dateTime = `${extractedData.date} ${extractedData.time}`;
                  const response = timeZoneFormat(dateTime, proTime, custTime);
                  const htmlContent = `Call ${
                    messageText?.includes("Rescheduled")
                      ? "Rescheduled"
                      : "Scheduled"
                  } for ${
                    user?.UserID === message?.customerId
                      ? response.custtimelast
                      : response.protimelast
                  } ${
                    message?.createdBy === user?.UserID ? proZone : custZone
                  } for 30 mins. <br/> Click to join zoom meeting <br/>  <a href="${
                    extractedData?.zoomLink
                  }" target="_blank"  style="
                    padding: 5px 15px;
                    border-radius: 6px;
                    border: 1px solid;
                    background-color: #0D6EFD;
                    color: white;
                  "> Join Call</a> <br/> Do you approve?`;

                  // let htmlContent;
                  // if (message?.zoomStatus === 3) {
                  //   if (message?.zoomRole === user?.UserID) {
                  //     htmlContent = `<div style=""><div style="display:flex;align-items:center;flex-direction: ${
                  //       window.innerWidth < 768 ? "column" : "row"
                  //     }">
                  //     <img src=${zoomLogo} style="height:100px;width:100px"/><div style="display:grid;margin-left:10px"><div style="font-weight:bold;font-size:16px">Call Scheduled for ${
                  //       response.protimelast
                  //     } ${
                  //       message?.zoomRole !== message?.createdBy
                  //         ? custZone
                  //         : proZone
                  //     } for 30 mins.</div><div><a href="${
                  //       extractedData?.zoomLink
                  //     }" target="_blank" style="text-decoration: underline !important;">Click here to join Zoom meeting</a></div><div>Do you approve?</div></div></div></div>`;
                  //   } else if (user.RoleId !== 1) {
                  //     htmlContent = `<div style=""><div style="display:flex;align-items:center;flex-direction: ${
                  //       window.innerWidth < 768 ? "column" : "row"
                  //     }">
                  //     <img src=${zoomLogo} style="height:100px;width:100px"/><div style="display:grid;margin-left:10px"><div style="font-weight:bold;font-size:16px">Call Scheduled for ${
                  //       response.custtimelast
                  //     } ${
                  //       message?.zoomRole !== message?.createdBy
                  //         ? proZone
                  //         : custZone
                  //     } for 30 mins.</div><div><a href="${
                  //       extractedData?.zoomLink
                  //     }" target="_blank" style="text-decoration: underline !important;">Click here to join Zoom meeting</a></div><div>Do you approve?</div></div></div></div>`;
                  //   } else {
                  //     htmlContent = `<div style=""><div style="display:flex;align-items:center;flex-direction: ${
                  //       window.innerWidth < 768 ? "column" : "row"
                  //     }"><img src=${zoomLogo} style="height:100px;width:100px"/><div style="display:grid; margin-left:10px"><div style="font-weight:bold;font-size:16px">Call Scheduled for ${
                  //       response.protimelast
                  //     } ${
                  //       message?.zoomRole !== message?.createdBy
                  //         ? custZone
                  //         : proZone
                  //     } for 30 mins.</div><div><a href="${
                  //       extractedData?.zoomLink
                  //     }" target="_blank" style="text-decoration: underline !important;">Click here to join Zoom meeting</a></div><div>Do you approve?</div></div></div></div>`;
                  //   }
                  // } else {
                  //   htmlContent = `<div style=""><div style="display:flex; align-items:center;flex-direction: ${
                  //     window.innerWidth < 768 ? "column" : "row"
                  //   }"><img src=${zoomLogo} style="height:100px;width:100px"/><div style="display:grid;margin-left:10px"><div style="font-weight:bold;font-size:16px">Call Scheduled for ${
                  //     response.protimelast
                  //   } ${
                  //     message?.zoomRole !== message?.createdBy
                  //       ? custZone
                  //       : proZone
                  //   } for 30 mins.</div><div><a href="${
                  //     extractedData?.zoomLink
                  //   }" target="_blank" style="text-decoration: underline !important;">Click here to join Zoom meeting</a></div><div>Do you approve?</div></div></div></div>`;
                  // }

                  return htmlContent;
                  // return htmlContent;
                }

                // Example messageText: "payment for chat with Payment, 400, COMPLETED"
                if (messageText.startsWith("payment for chat with")) {
                  // Remove the "payment for chat with" part
                  const paymentDetails = messageText
                    .replace("payment for chat with", "")
                    .trim();

                  // Split the remaining part based on commas
                  const detailsArray = paymentDetails
                    .split(",")
                    .map((item) => item.trim());

                  // Extract values from the detailsArray
                  paymentDescription = detailsArray[0]; // Payment Type
                  totalPrice = detailsArray[1]; // 400
                  PaymentStatus = detailsArray[2]; // COMPLETED

                  // Generate the HTML with dynamic values
                  const htmlContent = `<div style="display:flex;align-items:center;height:80px"><img src="${paypalLogo}" style="height:60px;width:60px"/><div style="margin-left:10px"><div style="font-weight:bold;font-size:23px">$ ${
                    message?.totalAmount
                  }</div><div>${
                    message?.orderMessage?.length > 30
                      ? `${message?.orderMessage.slice(0, 30)}...`
                      : message?.orderMessage
                  }</div><div>Payment Status: <span style="font-weight:bold; cursor:${
                    message?.createdBy === user?.UserID &&
                    message?.orderStatus !== "COMPLETED"
                      ? "pointer"
                      : "auto"
                  };color:${
                    message?.createdBy === user?.UserID
                      ? message?.orderStatus === "COMPLETED"
                        ? "#198754"
                        : "blue"
                      : message?.orderStatus === "COMPLETED"
                      ? "#198754"
                      : "black"
                  };text-decoration:${
                    message?.createdBy === user?.UserID &&
                    message?.orderStatus !== "COMPLETED"
                      ? "underline"
                      : "none"
                  }">${
                    message?.orderStatus === "PENDING"
                      ? `<span id="pendingPayment-${message.Id}">PENDING</span>`
                      : message?.orderStatus
                  }</span></div></div></div>`;
                  return htmlContent;
                }
                // Default case: Just render the message normally with the name.
                return messageText;
              })(),
            }}
          />
        )}
        {message?.postType == 4 && (
          <div>
            {renderAttachment()}
            <p
              className="my-1 p-0 text-dark attachment-title"
              style={{ fontSize: "medium",overflowWrap: "anywhere", }}
              dangerouslySetInnerHTML={{
                __html:
                  message.imageTitle ||
                  message.Message ||
                  message.messageComment ||
                  message.giftDescription ||
                  "",
              }}
            />

            <div
              style={{
                fontSize: "13.5px",
                color: "#666",
                lineHeight: "1.4",
                wordBreak: "break-word",
              }}
            >
              {message.imageDescription}
            </div>

            {message.imageId && message.createdBy && (
              <div
                style={{
                  // padding: "0 12px 12px",
                  textAlign: "center",
                }}
              >
                <a
                  href={`#/enlargeImageView?vendorid=${message.createdBy}&imageid=${message.imageId}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    window.location.hash = `#/enlargeImageView?vendorid=${message.createdBy}&imageid=${message.imageId}`;
                  }}
                  style={{
                    color: "#0d6efd",
                    fontWeight: "500",
                    fontSize: "13px",
                    textDecoration: "underline",
                  }}
                >
                  Click to View
                </a>
              </div>
            )}
          </div>
        )}
        <div
          className={`time text-dark mt-1 ${
            message.createdBy === userId ? "me-1" : "ms-1"
          }`}
          style={{
            textAlign:
              message.createdBy === userId ||
              (isAdmin &&
                (message.messageStatus === 13 || message.messageStatus === 14))
                ? "right"
                : "left",
          }}
        >
          {message.messageStatus == 0 &&
          message.scheduleDate &&
          message.scheduleTime ? (
            <span className="me-2">
              {message.messageStatus == 0 && "Scheduled For"} &nbsp;
              {moment
                .utc(`${message.scheduleDate}T${message.scheduleTime}:00Z`) // Ensure UTC format
                .tz(userTimeZone)
                .format("MMMM DD, YYYY hh:mm A")}
            </span>
          ) : (
            <span className="me-2">
              {moment
                .utc(message?.createdAt) // Ensure UTC before converting
                .tz(userTimeZone)
                .format("MMMM DD, YYYY hh:mm A")}
            </span>
          )}
          {message.messageStatus == 0 ? (
            <FaRegClock />
          ) : (
            <span className="ms-2 message-status">{getMessageStatus()}</span>
          )}
        </div>

        {message.messageStatus == 13 && (
          <div
            style={{
              textAlign:
                message.createdBy === userId ||
                (isAdmin && message.messageStatus == 13)
                  ? "right"
                  : "left",
              fontSize: "xx-small",
            }}
            className="mx-3 text-danger"
          >
            Admin Sending As Vendor
          </div>
        )}
        {message.messageStatus == 14 && (
          <div
            style={{
              textAlign:
                message.createdBy === userId ||
                (isAdmin && message.messageStatus == 14)
                  ? "right"
                  : "left",
              fontSize: "xx-small",
            }}
            className="mx-3 text-danger"
          >
            Admin scheduled As Vendor
          </div>
        )}
      </div>
      <Modal isOpen={modalIsOpen} toggle={closeModal}>
        <ModalBody>
          <div>
            <Label>
              Description <b className="text-danger">*</b>
            </Label>
            <Input
              type="textarea"
              name="descrption"
              placeholder="Please Enter Descrption"
              value={paymentDetails.description}
              // onChange={(e) => dispatch(setDescription(e.target.value))}
              disabled
            />
          </div>
          <div>
            <Label>Amount</Label>
            <InputGroup>
              <InputGroupText className="fw-bold">$</InputGroupText>
              <Input
                type="number"
                name="amount"
                placeholder="amount"
                value={paymentDetails.amount}
                // onChange={handleAmountChange}
                disabled
              />
            </InputGroup>
            <div>
              <Payment
                totalPrice={Number(paymentDetails.amount)}
                state={{ chatPay: true }}
                chatDetails={true}
              />
            </div>
          </div>
        </ModalBody>
      </Modal>
      {reScheduleModal && (
        <MsgScheduleModal
          open={reScheduleModal}
          close={() => setRescheduleModal(false)}
          msg={selectedConvo}
          isChatModal={isChatModal}
          editMsg={message}
        />
      )}
    </div>
  );
}

export default Conversation;
